import React from 'react'
import { PropTypes } from 'prop-types'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'

import ActionLogic from 'components/Util/ActionLogic'

import createBosAccessHash from 'graphql/bos/createBosAccessHash.gql'
import deleteBosAccessHash from 'graphql/bos/deleteBosAccessHash.gql'
import getBillOfSale from 'graphql/bos/getBillOfSaleWithoutVehicle.gql'

class BosShareLogic extends React.Component {
    createBosAccessHash = async (actionLogic, bosId) => {
        return actionLogic.callMutation(this.props.createBosAccessHash, {
            variables: {
                bosId: parseInt(bosId),
            },
            refetchQueries: [{
                query: getBillOfSale,
                variables: {
                    bosId: bosId,
                },
            }],
            awaitRefetchQueries: true,
        })
    }

    deleteBosAccessHash = async (actionLogic, bosId, linkId) => {
        return actionLogic.callMutation(this.props.deleteBosAccessHash, {
            variables: {
                linkId: parseInt(linkId),
            },
            refetchQueries: [{
                query: getBillOfSale,
                variables: {
                    bosId: bosId,
                },
            }],
            awaitRefetchQueries: true,
        })
    }

    getRenderProps = (actionLogic) => {
        return {
            ...actionLogic,
            createBosAccessHash: (...args) => this.createBosAccessHash(actionLogic, ...args),
            deleteBosAccessHash: (...args) => this.deleteBosAccessHash(actionLogic, ...args),
        }
    }

    handleMount = (actionLogic) => {
        const { onMount } = this.props
        onMount && onMount(this.getRenderProps(actionLogic))
    }

    render () {
        const { initState, children } = this.props

        return (
            <ActionLogic initState={initState} onMount={this.handleMount}>
                {(actionLogic) => {
                    return children(this.getRenderProps(actionLogic))
                }}
            </ActionLogic>
        )
    }
}

BosShareLogic.propTypes = {
    children: PropTypes.func.isRequired,
    initState: PropTypes.object,
}

export default flowRight(
    withRouter,
    graphql(createBosAccessHash, {
        name: 'createBosAccessHash',
    }),
    graphql(deleteBosAccessHash, {
        name: 'deleteBosAccessHash',
    }),
)(BosShareLogic)
